/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'app/utils/loadable';

export const EquityExposureReportPage = lazyLoad(
  () => import('./index'),
  module => module.EquityExposureReportPage,
);
